import React from 'react';
export function CallToAction() {
  return <section className="py-16 bg-amber-600" data-id="element-70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-71">
        <h2 className="text-3xl font-bold text-white mb-6" data-id="element-72">
          Ready to Take the Next Step in Your Catering Career?
        </h2>
        <p className="text-amber-100 text-lg max-w-3xl mx-auto mb-8" data-id="element-73">
          Join thousands of catering professionals who have found their dream
          jobs through our platform.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4 max-w-md mx-auto" data-id="element-74">
          <a href="#" className="bg-white text-amber-600 px-6 py-3 rounded-md hover:bg-gray-100 transition font-medium" data-id="element-75">
            Find Jobs
          </a>
          <a href="#" className="bg-amber-800 text-white px-6 py-3 rounded-md hover:bg-amber-900 transition font-medium" data-id="element-76">
            Post a Job
          </a>
        </div>
      </div>
    </section>;
}